module.exports = __webpack_public_path__ + "static/img/padWarn.a43d408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padWarn.png
// module id = CiRB
// module chunks = 1